import React, { Component, PropTypes } from 'react';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';

class ConfirmationConfiguration extends Component {
    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }

    render() {
        return (
            <div className="spark-panel__content col-lg-12">
                <h4>Confirmation Settings</h4>
                <div className="spark-panel__content col-lg-12">
                    <ConfigurationCheckbox
                        title="Show HTML Area"
                        isDisabled={this.props.isDisabled}
                        code="showhtmlArea"
                        onChange={this.props.toggleConfigBoolean}
                        value={this.props.currentConfigCopy.showhtmlArea}
                    />
                    <ConfigurationCheckbox
                        title="Show Marketing Message"
                        isDisabled={this.props.isDisabled}
                        code="showMarketingMessage"
                        onChange={this.props.toggleConfigBoolean}
                        value={this.props.currentConfigCopy.showMarketingMessage}
                    />
                    <ReactSparkTextInput
                        label="HTML Area"
                        name="theme-name"
                        value={this.props.currentConfigCopy.htmlArea}
                        isDisabled={this.props.isDisabled}
                        onChange={event => {
                            this.props.setConfigText('htmlArea', event.target.value);
                        }}
                        onBlur={event => {
                            this.props.setConfigText('htmlArea', event.target.value);
                        }}
                    />
                </div>
            </div>
        );
    }
}

ConfirmationConfiguration.propTypes = {
    children: PropTypes.element
};

export default ConfirmationConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/ConfirmationConfiguration.js